<div class="empty-state" [class.empty-state--compact]="compact" role="status">
  <span class="empty-state__icon" aria-hidden="true">
    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  </span>
  <p class="empty-state__title">{{ titleKey | translate }}</p>
  <p class="empty-state__message">{{ messageKey | translate }}</p>
  <button
    *ngIf="ctaKey"
    type="button"
    class="empty-state__cta"
    (click)="ctaClick.emit()"
  >
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
      <path d="M12 5v14M5 12h14" />
    </svg>
    {{ ctaKey | translate }}
  </button>
</div>
